import { Component, OnInit, inject, signal } from '@angular/core';
import { AppService } from '@app/core/services/app.service';

@Component({
    selector: 'app-instruction',
    templateUrl: './instruction.component.html',
    styleUrls: ['./instruction.component.scss'],
    imports: []
})
export class InstructionComponent implements OnInit {
  private readonly appService = inject(AppService);

  public isExpanded = signal(false);
  public acceptedEulaSignal = this.appService.acceptedEulaSignal;

  ngOnInit(): void {
    if (this.acceptedEulaSignal()) {
      this.isExpanded.set(true);
    }
  }

  onClickContinue() {
    if (this.acceptedEulaSignal()) {
      this.appService.navigateWithUrlSuffix('exhibition');
      this.appService.showDialogIfFirstStart();
    } else {
      this.appService.navigateWithUrlSuffix('profile');
    }
  }

}
